export default "__VITE_ASSET__BnPWk3nD__"